<script setup>
import { cloneDeep, groupBy, isEqual } from 'lodash-es';
import { computed } from 'vue';
import { useBarcodeScanHelper } from '~/terra/composables/barcode-scan-helper.composable';
import { useTerraStore } from '~/terra/store/terra.store.js';

const terra_store = useTerraStore();
const { STATUS_LABELS, STATUS_COLORS } = useBarcodeScanHelper();

const inactive_statuses = computed(() => terra_store.barcode_scan_map_settings.inactive_statuses);

const grouped_by_status = computed(() => {
  return groupBy(terra_store.barcode_scan_all_features, item => item.properties.barcode_scan_status);
});

async function disableAllButOne(key) {
  const inactive_statuses = cloneDeep(terra_store.barcode_scan_map_settings.inactive_statuses);
  const updated_inactive_statuses = Object.keys(grouped_by_status.value).filter(item => item !== key);
  if (isEqual(inactive_statuses, updated_inactive_statuses))
    terra_store.barcode_scan_map_settings.inactive_statuses = [];
  else
    terra_store.barcode_scan_map_settings.inactive_statuses = updated_inactive_statuses;
  await terra_store.update_map_features_and_polygon();
}
async function toggleStatus(key) {
  const inactive_statuses = cloneDeep(terra_store.barcode_scan_map_settings.inactive_statuses);
  if (inactive_statuses.includes(key)) {
    inactive_statuses.splice(inactive_statuses.indexOf(key), 1);
  }
  else {
    inactive_statuses.push(key);
  }
  terra_store.barcode_scan_map_settings.inactive_statuses = inactive_statuses;
  await terra_store.update_map_features_and_polygon();
}
</script>

<template>
  <div class="h-full overflow-auto scrollbar p-4">
    <div class="flex items-center justify-between mb-6">
      <div class="text-base font-semibold">
        {{ $t('Status') }}
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <div v-for="(value, key) in grouped_by_status" :key="key" class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <div class="h-4 w-4 rounded-full" :style="`background-color:${STATUS_COLORS[key]}`" />
          <div class="text-sm font-medium cursor-pointer" :class="{ 'line-through text-gray-500': inactive_statuses.includes(key) }" @click.stop="toggleStatus(key)">
            {{ STATUS_LABELS[key] }}
          </div>
        </div>
        <HawkBadge class="text-sm font-medium cursor-pointer" @click.stop="disableAllButOne(key)">
          {{ value.length }}
        </HawkBadge>
      </div>
    </div>
  </div>
</template>
